import header from "./grundrisse-auf-tablet.png";
import section1 from "./grundriss-wird-auf-tablet-gzeichnet.png";
import section2 from "./grundriss-online-erstellen.webp"; //noshadow needed
import section3 from "./grundrisse-von-kuechen.png";
import section4 from "./grundriss-online-beantragen.png";
import section5 from "./diverse-grundrisse.png";
import section6 from "./grundriss-online-designen.jpg";

export { header, section1, section2, section3, section4, section5, section6 };
